import React, { forwardRef, useRef } from "react";
import EpisodeCard from "../VideoCard/VideoCard";

const FiveRow = forwardRef(({ category }) => {
  const episodeRefs = useRef([]);

  return (
    <div id="fiveRow" className="row">
                <div className="col">
                  {category.series?.[0] && category.series[0].episodes?.[0] && (
                    <EpisodeCard
                      episode={category.series[0].episodes[0]}
                      series={category.series[0]}
                      ref={(el) => el && episodeRefs.current.push(el)}
                    />
                  )}
                </div>
                <div className="col">
                  <div className="row">
                    <div className="col">
                      {category.series?.[0] &&
                        category.series[0].episodes?.[1] && (
                          <EpisodeCard
                            episode={category.series[0].episodes[1]}
                            series={category.series[0]}
                            ref={(el) => el && episodeRefs.current.push(el)}
                          />
                        )}
                    </div>
                    <div className="col">
                      {category.series?.[0] &&
                        category.series[0].episodes?.[2] && (
                          <EpisodeCard
                            episode={category.series[0].episodes[2]}
                            series={category.series[0]}
                            ref={(el) => el && episodeRefs.current.push(el)}
                          />
                        )}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col">
                      {category.series?.[0] &&
                        category.series[0].episodes?.[3] && (
                          <EpisodeCard
                            episode={category.series[0].episodes[3]}
                            series={category.series[0]}
                            ref={(el) => el && episodeRefs.current.push(el)}
                          />
                        )}
                    </div>
                    <div className="col">
                      {category.series?.[0] &&
                        category.series[0].episodes?.[4] && (
                          <EpisodeCard
                            episode={category.series[0].episodes[4]}
                            series={category.series[0]}
                            ref={(el) => el && episodeRefs.current.push(el)}
                          />
                        )}
                    </div>
                  </div>
                </div>
              </div>
  );
    
}); 

export default FiveRow;
